import React, { useState } from 'react'
import styled from 'styled-components'
import profile from './assets/profile_img.png';
import { useEffect, useMemo } from 'react';
import axios from 'axios';
import userEvent from '@testing-library/user-event';
import { useDispatch, useSelector } from "react-redux";
import { data } from 'jquery';
import FindPodsDetails from './FindPodsDetails'
import { NavHashLink } from 'react-router-hash-link';
import star from './assets/star.png';
import Createpod from './Createpod';
import AWS from 'aws-sdk';
import defaultimg from './assets/defaultimge.png';
import { useAuthToken } from "../TokenContext";
import { useIntl } from 'react-intl';
import { useCredentials } from '../useCredentials';
import { useTheme } from '@mui/material';
import { FaUsers, FaEnvelope, FaPhone, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { MdPeople } from 'react-icons/md';

const FindPods = ({ collapsed }) => {
  const token = useAuthToken();
  const intl = useIntl();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const [Subscription, setSubscription] = useState({});
  const [subscriptionFetch, setSubscriptionFetch] = useState([]);
  const [loading, setLoading] = useState(true);
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();

  const config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  const S3Config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6); // Increased for better grid layout
  const [AuthImage, setAuthImage] = useState([]);
  const [pageNumberLimit, setPageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [getData, setGetData] = useState([]);
  const [GetCandidates, setGetCandidates] = useState([]);
  const [requirement, setRequirement] = useState([]);

  useEffect(() => {
    if (user && user.data && user.data.length > 0) {
      const body = {
        client_code: user.data[0].talent_code,
      };

      const headers = {
        Authorization: token,
        'Content-Type': 'application/json',
      };

      axios
        .post(process.env.REACT_APP_FETCHSUBSCRIPTIONDATA, body, { headers })
        .then((res) => {
          setSubscription(res.data.data);
          setSubscriptionFetch(res.data.data[0]?.find_pods || []);
        })
        .catch((err) => {
          console.log('catch', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token, user]);

  const myBucket = new AWS.S3(S3Config);

  useEffect(() => {
    const fetchData = async () => {
      if (user && user.data && user.data.length > 0) {
        const headers = {
          Authorization: token,
          'Content-Type': 'application/json',
        };

        try {
          const body = {
            primary_skills: user.data[0].primaryskill,
            secondary_skills: user.data[0].secondaryskill,
            Client_Code: user.data[0].talent_code,
          };

          let findPod = await axios.post(
            process.env.REACT_APP_TALENT_FINDPODS,
            body,
            { headers }
          );

          if (findPod.data && findPod.data.data && findPod.data.data.length > 0) {
            setGetData(findPod.data.data);
            const URL_EXPIRATION_TIME = 900;

            const params = {
              Bucket: process.env.REACT_APP_BUCKETNAME,
              Key: findPod.data.data[0].picture,
              Expires: URL_EXPIRATION_TIME,
            };

            myBucket.getSignedUrl('getObject', params, (err, url) => {
              if (err) {
                console.log(err);
              } else {
                setAuthImage(url);
              }
            });
          } else {
            console.error('findPod.data.data is undefined or empty');
          }

          const getPodBody = {
            candidateID: user.data[0].c_id,
          };

          let getPod = await axios.post(
            process.env.REACT_APP_CLIENT_GETCANDIDATEPODS,
            getPodBody,
            { headers }
          );

          setGetCandidates(getPod.data.data.candidates);
        } catch (err) {
          console.log(err);
        }
      }
    };

    fetchData();
  }, [token, user]);

  const handleClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pages = [];
  if (getData && getData.length > 0) {
    for (let i = 1; i <= Math.ceil(getData.length / itemsPerPage); i++) {
      pages.push(i);
    }
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = getData.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextBtn = () => {
    if (currentPage < pages.length) {
      setCurrentPage(currentPage + 1);
      if (currentPage + 1 > maxPageNumberLimit) {
        setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
        setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit);
      }
    }
  };

  const handlePrevBtn = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      if ((currentPage - 1) % pageNumberLimit === 0) {
        setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
        setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit);
      }
    }
  };

  if (loading) {
    return (
      <div className="artemy-fade-up" style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '40px' }}>
        <LoadingState isDarkMode={isDarkMode}>
          <LoadingSpinner isDarkMode={isDarkMode} />
          <LoadingText isDarkMode={isDarkMode}>
            {intl.formatMessage({ id: 'loading' })}...
          </LoadingText>
        </LoadingState>
      </div>
    );
  }

  if (Subscription === "There Are No subscription data." || subscriptionFetch === "False") {
    return (
      <div className="artemy-fade-up" style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '40px' }}>
        <EmptyState isDarkMode={isDarkMode}>
          <EmptyIcon>🔒</EmptyIcon>
          <EmptyTitle isDarkMode={isDarkMode}>
            Subscription Required
          </EmptyTitle>
          <EmptyDescription isDarkMode={isDarkMode}>
            {intl.formatMessage({ id: 'noSubscription' })}
          </EmptyDescription>
        </EmptyState>
      </div>
    );
  }

  return (
    <div className="artemy-fade-up">

      <div style={{ marginBottom: '32px' }}>
        <h1 className="artemy-page-title">
          {intl.formatMessage({ id: 'findBestPod' })}
        </h1>
        <p className="artemy-page-sub">
          Discover the perfect POD that matches your skills and requirements
        </p>
      </div>

      {getData.length > 0 ? (
        <>
          <PodsGrid>
            {currentItems.map((pod, index) => (
              <div key={index} className="artemy-card artemy-fade-up" style={{ padding: '24px', animationDelay: `${index * 0.05}s` }}>
                <PodHeader>
                  <ProfileSection>
                    <ProfileImage>
                      {pod.picture == null || pod.picture === "" ? (
                        <img
                          src={defaultimg}
                          alt="Pod leader"
                          style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '12px',
                            objectFit: 'cover',
                            border: '1px solid var(--artemy-border)'
                          }}
                        />
                      ) : (
                        <img
                          src={`https://globldataprod.s3.amazonaws.com/${pod.picture}`}
                          alt="Pod leader"
                          style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '12px',
                            objectFit: 'cover',
                            border: '1px solid var(--artemy-border)'
                          }}
                        />
                      )}
                    </ProfileImage>
                    <RatingSection style={{ background: 'rgba(245, 166, 35, 0.1)', border: '1px solid rgba(245, 166, 35, 0.2)', padding: '4px 12px' }}>
                      <StarIcon style={{ color: 'var(--artemy-yellow)' }}>
                        <FaStar />
                      </StarIcon>
                      <RatingText style={{ color: 'var(--artemy-yellow)', fontSize: '12px' }}>
                        {pod.rating || 'N/A'}
                      </RatingText>
                    </RatingSection>
                  </ProfileSection>
                </PodHeader>

                <PodContent style={{ marginTop: '20px' }}>
                  <h3 style={{
                    fontFamily: 'var(--artemy-font-display)',
                    fontSize: '18px',
                    fontWeight: 600,
                    color: 'var(--artemy-text-primary)',
                    marginBottom: '16px'
                  }}>
                    {pod.podName}
                  </h3>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <FaEnvelope style={{ color: 'var(--artemy-accent)', fontSize: '14px' }} />
                      <span style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)' }}>{pod.email}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <FaPhone style={{ color: 'var(--artemy-accent)', fontSize: '14px' }} />
                      <span style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)' }}>{pod.phone}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <MdPeople style={{ color: 'var(--artemy-accent)', fontSize: '14px' }} />
                      <span style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)' }}>{pod.podSize} members</span>
                    </div>
                  </div>
                </PodContent>

                <div style={{ marginTop: '24px' }}>
                  <button className="artemy-btn artemy-btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </PodsGrid>

          {pages.length > 1 && (
            <PaginationContainer>
              <button
                onClick={handlePrevBtn}
                className="artemy-btn artemy-btn-ghost"
                disabled={currentPage === 1}
              >
                <FaChevronLeft />
                {intl.formatMessage({ id: 'prev' })}
              </button>

              <PageNumbers>
                {pages
                  .filter(number => number >= minPageNumberLimit + 1 && number <= maxPageNumberLimit)
                  .map((number) => (
                    <button
                      key={number}
                      onClick={() => handleClick(number)}
                      className={`artemy-btn ${currentPage === number ? 'artemy-btn-primary' : 'artemy-btn-ghost'}`}
                      style={{ minWidth: '40px', justifyContent: 'center' }}
                    >
                      {number}
                    </button>
                  ))}
              </PageNumbers>

              <button
                onClick={handleNextBtn}
                className="artemy-btn artemy-btn-ghost"
                disabled={currentPage === pages.length}
              >
                {intl.formatMessage({ id: 'next' })}
                <FaChevronRight />
              </button>
            </PaginationContainer>
          )}
        </>
      ) : (
        <div className="artemy-card" style={{ textAlign: 'center', padding: '60px 20px', borderStyle: 'dashed' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
          <h3 style={{ fontFamily: 'var(--artemy-font-display)', fontSize: '20px', color: 'var(--artemy-text-primary)' }}>
            No PODs Found
          </h3>
          <p style={{ fontSize: '14px', color: 'var(--artemy-text-secondary)', marginTop: '8px' }}>
            {intl.formatMessage({ id: 'noData' })}
          </p>
        </div>
      )}
    </div>
  );
};

const PodsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
`;

const PodHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const ProfileImage = styled.div`
  flex-shrink: 0;
`;

const RatingSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 100px;
  margin-left: auto;
`;

const StarIcon = styled.div`
  display: flex;
  align-items: center;
`;

const RatingText = styled.span`
  font-weight: 600;
`;

const PodContent = styled.div`
  flex: 1;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 40px;
  padding-bottom: 40px;
`;

const PageNumbers = styled.div`
  display: flex;
  gap: 8px;
`;

const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)'};
  padding: 40px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
  border-top: 3px solid var(--artemy-accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.div`
  color: ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)'};
  font-size: 14px;
  font-weight: 500;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 60px 40px;
  background: ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 32px;
  border: 1px dashed ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
  max-width: 500px;
  width: 100%;
`;

const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 24px;
`;

const EmptyTitle = styled.h3`
  font-family: var(--artemy-font-display);
  font-size: 24px;
  color: ${props => props.isDarkMode ? '#ffffff' : '#1e293b'};
  margin-bottom: 12px;
  font-weight: 600;
`;

const EmptyDescription = styled.p`
  color: ${props => props.isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'rgba(30, 41, 59, 0.6)'};
  font-size: 15px;
  line-height: 1.6;
`;

export default FindPods;
